webpackJsonp([3999167419416],{

/***/ 751:
/***/ (function(module, exports) {

	module.exports = {"Fiber":{"m":30,"f":30,"units":"g"},"Vitamin A":{"m":600,"f":700,"units":"µg"},"Thiamin":{"m":1,"f":0.8,"units":"mg"},"Riboflavin":{"m":1.3,"f":1.1,"units":"mg"},"Niacin":{"m":16.5,"f":13.2,"units":"mg"},"Pantothenic Acid":{"m":17,"f":13,"units":"mg"},"Vitamin B6":{"m":1.4,"f":1.2,"units":"mg"},"Biotin":{"m":0.05,"f":0.05,"units":"mg"},"Folate":{"m":200,"f":400,"units":"µg"},"Vitamin B12":{"m":1.5,"f":1.5,"units":"µg"},"Vitamin C":{"m":40,"f":40,"units":"mg"},"Vitamin D":{"m":200,"f":200,"units":"IU"},"Vitamin E":{"m":10,"f":10,"units":"mg"},"Vitamin K":{"m":75,"f":75,"units":"µg"},"Calcium":{"m":700,"f":700,"units":"mg"},"Iron":{"m":8.7,"f":14.8,"units":"mg"},"Magnesium":{"m":300,"f":270,"units":"mg"},"Phosphorus":{"m":550,"f":550,"units":"mg"},"Potassium":{"m":3500,"f":3500,"units":"mg"},"Sodium":{"m":2400,"f":2400,"units":"mg"},"Zinc":{"m":9.5,"f":7,"units":"mg"},"Fatty acids":{"m":30,"f":20,"units":"g"},"Energy":{"m":2500,"f":2000,"units":"kcal"},"Carbohydrate":{"m":260,"f":260,"units":"g"},"Protein":{"m":50,"f":50,"units":"g"},"Sugars":{"m":30,"f":30,"units":"g"}}

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _IconPaths = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Paths
	
	
	var DEBUG = false;
	var NUM_BUBBLES = 5;
	
	var FlaskIcon = function (_React$Component) {
	  _inherits(FlaskIcon, _React$Component);
	
	  function FlaskIcon(props) {
	    _classCallCheck(this, FlaskIcon);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._bubbles = [];
	    _this._icon = null;
	    _this._motionPaths = _lodash2.default.times(NUM_BUBBLES, function () {
	      return null;
	    });
	    return _this;
	  }
	
	  FlaskIcon.prototype._initAnimations = function _initAnimations() {
	    var _this2 = this;
	
	    var startShape = this._icon.querySelector('#liquid-1');
	    var endShape = this._icon.querySelector('#liquid-2');
	
	    var startPathData = startShape.getAttribute('d');
	    var endPathData = endShape.getAttribute('d');
	
	    TweenMax.to(startShape, 1, {
	      morphSVG: endPathData,
	      // ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true,
	      force3D: true
	    });
	
	    _lodash2.default.times(NUM_BUBBLES, function (i) {
	      var bezierData = MorphSVGPlugin.pathDataToBezier(_this2._motionPaths[i], {
	        align: _this2._bubbles[i]
	      });
	      TweenMax.set(_this2._bubbles[i], { xPercent: -50, yPercent: -50 });
	      TweenMax.to(_this2._bubbles[i], 2, {
	        opacity: 0,
	        bezier: {
	          values: bezierData,
	          type: 'cubic'
	        },
	        ease: Linear.easeNone,
	        repeat: -1,
	        yoyo: false,
	        delay: 0.4 * i
	      });
	    });
	  };
	
	  FlaskIcon.prototype.componentDidMount = function componentDidMount() {
	    this._initAnimations();
	  };
	
	  FlaskIcon.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        colors = _props.colors,
	        height = _props.height,
	        width = _props.width;
	
	    var baseIconColor = colors.length > 1 ? colors[1] : colors[0];
	    var bubbleColor = colors[0];
	    return _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 100 100', width: width, height: height },
	      _react2.default.createElement(
	        'g',
	        { ref: function ref(icon) {
	            _this3._icon = icon;
	          } },
	        _react2.default.createElement(_IconPaths.Flask, { transform: 'translate(0, 20)', liquidColor: baseIconColor })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _lodash2.default.times(NUM_BUBBLES, function (i) {
	          return _react2.default.createElement('circle', {
	            key: 'bubble-' + i,
	            ref: function ref(bubble) {
	              _this3._bubbles[i] = bubble;
	            },
	            cx: 0,
	            cy: 0,
	            r: NUM_BUBBLES - i,
	            fill: bubbleColor,
	            stroke: 'white' });
	        })
	      ),
	      _lodash2.default.times(NUM_BUBBLES, function (i) {
	        var stretchfactor = 20 * i / NUM_BUBBLES;
	        return _react2.default.createElement('path', {
	          key: 'motionPath-' + i,
	          ref: function ref(motionPath) {
	            _this3._motionPaths[i] = motionPath;
	          },
	          d: 'M 50,75 C ' + (50 - stretchfactor) + ',50 ' + (50 + stretchfactor) + ',25 50,5',
	          stroke: DEBUG ? 'cornflowerblue' : 'none',
	          fill: 'none' });
	      })
	    );
	  };
	
	  return FlaskIcon;
	}(_react2.default.Component);
	
	;
	
	FlaskIcon.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	FlaskIcon.defaultProps = {
	  colors: ['black'],
	  width: 200,
	  height: 200
	};
	
	exports.default = FlaskIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _IconPaths = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Paths
	
	
	var HeartIcon = function (_React$Component) {
	  _inherits(HeartIcon, _React$Component);
	
	  function HeartIcon(props) {
	    _classCallCheck(this, HeartIcon);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._icon = null;
	    return _this;
	  }
	
	  HeartIcon.prototype._initAnimations = function _initAnimations() {
	    TweenMax.to(this._icon, 0.2, {
	      scale: 1.1,
	      transformOrigin: '50% 50%',
	      ease: Power2.easeInOut,
	      repeat: 10,
	      yoyo: true
	    });
	  };
	
	  HeartIcon.prototype.componentDidMount = function componentDidMount() {
	    this._initAnimations();
	  };
	
	  HeartIcon.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        color = _props.color,
	        height = _props.height,
	        width = _props.width;
	
	    return _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 100 100', width: width, height: height },
	      _react2.default.createElement(
	        'g',
	        { ref: function ref(icon) {
	            _this2._icon = icon;
	          } },
	        _react2.default.createElement(_IconPaths.Heart, { strokeColor: color, transform: 'translate(0, 0)' })
	      )
	    );
	  };
	
	  return HeartIcon;
	}(_react2.default.Component);
	
	;
	
	HeartIcon.propTypes = {
	  color: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	HeartIcon.defaultProps = {
	  color: 'black',
	  width: 200,
	  height: 200
	};
	
	exports.default = HeartIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Flask = exports.Podium = exports.Munch = exports.Heart = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Heart = exports.Heart = function Heart(_ref) {
	  var _ref$strokeColor = _ref.strokeColor,
	      strokeColor = _ref$strokeColor === undefined ? 'black' : _ref$strokeColor,
	      transform = _ref.transform;
	  return _react2.default.createElement(
	    'g',
	    { transform: transform },
	    _react2.default.createElement('path', {
	      fill: 'none',
	      stroke: strokeColor,
	      strokeWidth: 1,
	      d: 'M50.002,20.532C29.919-3.799-12.5,21.679,12.851,57.393c10.002,14.08,37.151,31.672,37.151,31.672  c0.013-0.01,27.145-17.592,37.147-31.672C112.5,21.679,70.081-3.799,50.002,20.532z' })
	  );
	};
	
	var Munch = exports.Munch = function Munch(_ref2) {
	  var _ref2$strokeColor = _ref2.strokeColor,
	      strokeColor = _ref2$strokeColor === undefined ? 'black' : _ref2$strokeColor,
	      transform = _ref2.transform;
	  return _react2.default.createElement(
	    'g',
	    { transform: transform },
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('path', { id: 'lip-top', d: '\n      M 20 50\n      C 20 70, 80 70, 80 50\n      ', stroke: strokeColor, strokeLinecap: 'round', strokeWidth: 2, fill: 'none' }),
	      _react2.default.createElement('path', { id: 'lip-bottom', d: '\n        M 20 50\n        C 20 60, 80 60, 80 50\n        ', stroke: strokeColor, strokeLinecap: 'round', strokeWidth: 2, fill: 'none' }),
	      _react2.default.createElement('path', { id: 'mouth-closed', d: '\n        M 20 50\n        C 20 60, 80 65, 80 50\n        ', stroke: 'none', fill: 'none' }),
	      _react2.default.createElement('path', { id: 'cheek-left', d: '\n        M 20 45\n        q 0 12, -4 15\n        ', stroke: strokeColor, strokeLinecap: 'round', strokeWidth: 2, fill: 'none' }),
	      _react2.default.createElement('path', { id: 'cheek-left-a', d: '\n        M 20 40\n        q 2 12, -8 20\n        ', stroke: 'none', strokeLinecap: 'round', strokeWidth: 2, fill: 'none' }),
	      _react2.default.createElement('path', { id: 'cheek-right', d: '\n        M 80 45\n        q 0 12, 4 15\n        ', stroke: strokeColor, strokeLinecap: 'round', strokeWidth: 2, fill: 'none' }),
	      _react2.default.createElement('path', { id: 'cheek-right-a', d: '\n        M 80 40\n        q -2 12, 8 20\n        ', stroke: 'none', fill: 'none' })
	    ),
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('path', { id: 'motion-path-1', d: '\n        M 90 100\n        q 0 -30 -40 -40\n      ', stroke: 'none', fill: 'none' }),
	      _react2.default.createElement('path', { id: 'motion-path-2', d: '\n        M 10 100\n        q 0 -30 40 -40\n      ', stroke: 'none', fill: 'none' })
	    )
	  );
	};
	
	var Podium = exports.Podium = function Podium(_ref3) {
	  var transform = _ref3.transform,
	      _ref3$strokeColor = _ref3.strokeColor,
	      strokeColor = _ref3$strokeColor === undefined ? 'white' : _ref3$strokeColor,
	      _ref3$fill = _ref3.fill,
	      fill = _ref3$fill === undefined ? 'black' : _ref3$fill,
	      _ref3$nodeColors = _ref3.nodeColors,
	      nodeColors = _ref3$nodeColors === undefined ? ['black', 'black', 'black'] : _ref3$nodeColors;
	  return _react2.default.createElement(
	    'g',
	    { transform: transform },
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('path', { id: 'podium-rect-1', d: '\n        M 0 71\n        q 0 -5, 5 -5\n        c 3 0, 6 0, 9 0\n        c 3 0, 6 0, 9 0\n        q 5 0,5 5 v 29 h -28 Z\n        ', fill: fill }),
	      _react2.default.createElement('path', { id: 'podium-rect-1a', d: '\n        M 0 71\n        q 0 -5, 5 -5\n        c 3 0, 6 3, 9 3\n        c 3 0, 6 -3, 9 -3\n        q 5 0,5 5 v 29 h -28 Z\n        ', fill: 'none' }),
	      _react2.default.createElement('path', { id: 'podium-rect-2', d: '\n        M 36 65\n        q 0 -5, 5 -5\n        c 3 0, 6 0, 9 0\n        c 3 0, 6 0, 9 0\n        q 5 0,5 5\n        v 35 h -28 Z\n      ', fill: fill }),
	      _react2.default.createElement('path', { id: 'podium-rect-2a', d: '\n        M 36 65\n        q 0 -5, 5 -5\n        c 3 0, 6 3, 9 3\n        c 3 0, 6 -3, 9 -3\n        q 5 0,5 5\n        v 35 h -28 Z\n      ', fill: 'none' }),
	      _react2.default.createElement('path', { id: 'podium-rect-3', d: '\n        M 72 81\n        q 0 -5, 5 -5\n        c 3 0, 6 0, 9 0\n        c 3 0, 6 0, 9 0\n        q 5 0,5 5\n        v 29 h -28 Z\n      ', fill: fill }),
	      _react2.default.createElement('path', { id: 'podium-rect-3a', d: '\n        M 72 81\n        q 0 -5, 5 -5\n        c 3 0, 6 3, 9 3\n        c 3 0, 6 -3, 9 -3\n        q 5 0,5 5\n        v 29 h -28 Z\n      ', fill: 'none' })
	    ),
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('circle', { id: 'podium-circle-1', stroke: strokeColor, strokeWidth: 1, fill: nodeColors[0], r: 8, cx: 14, cy: 56 }),
	      _react2.default.createElement('circle', { id: 'podium-circle-2', stroke: strokeColor, strokeWidth: 1, fill: nodeColors[1], r: 10, cx: 50, cy: 50 }),
	      _react2.default.createElement('circle', { id: 'podium-circle-3', stroke: strokeColor, strokeWidth: 1, fill: nodeColors[2], r: 7, cx: 86, cy: 66 })
	    )
	  );
	};
	var Flask = exports.Flask = function Flask(_ref4) {
	  var transform = _ref4.transform,
	      _ref4$liquidColor = _ref4.liquidColor,
	      liquidColor = _ref4$liquidColor === undefined ? 'black' : _ref4$liquidColor,
	      _ref4$flaskColor = _ref4.flaskColor,
	      flaskColor = _ref4$flaskColor === undefined ? 'black' : _ref4$flaskColor;
	  return _react2.default.createElement(
	    'g',
	    { transform: transform },
	    _react2.default.createElement('path', { id: 'liquid-1', d: 'M 67.771 67.945 L 57.605 53.427 C 55,58 45,48 42.395 53.427 L 32.229 67.945 c 0 0 -2.762 3.762 2.562 3.762 c 5.604 0 15.209 0 15.209 0 s 9.604 0 15.209 0 C 70.532 71.707 67.771 67.945 67.771 67.945 z', fill: liquidColor }),
	    _react2.default.createElement('path', { id: 'liquid-2', d: 'M 67.771 67.945 L 57.605 53.427 C 55,48 45,58 42.395 53.427 L 32.229 67.945 c 0 0 -2.762 3.762 2.562 3.762 c 5.604 0 15.209 0 15.209 0 s 9.604 0 15.209 0 C 70.532 71.707 67.771 67.945 67.771 67.945 z', fill: 'none' }),
	    _react2.default.createElement('path', { d: 'M69,75H31.002c-2,0-3.29-0.557-3.835-1.656c-1.115-2.252,1.473-5.755,1.771-6.146L44.17,45.012V25.5h1v19.822    L29.748,67.783c-0.721,0.949-2.398,3.677-1.685,5.118C28.426,73.63,29.414,74,31.002,74H69c1.588,0,2.576-0.37,2.938-1.099    c0.714-1.441-0.964-4.169-1.67-5.099l-15.437-22.48V25.5h1v19.512l15.246,22.205c0.284,0.372,2.872,3.875,1.757,6.127    C72.29,74.443,71,75,69,75z', fill: flaskColor })
	  );
	};

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEBUG = false;
	var ANIM_DURATION = 2;
	var NUM_ATOMS_PER_RING = 2;
	var NUM_RINGS = 3;
	
	var MoleculeIcon = function (_React$Component) {
	  _inherits(MoleculeIcon, _React$Component);
	
	  function MoleculeIcon(props) {
	    _classCallCheck(this, MoleculeIcon);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._icon = null;
	    _this._motionPaths = _lodash2.default.times(NUM_RINGS, function () {
	      return null;
	    });
	    _this._atoms = _lodash2.default.times(6, function () {
	      return null;
	    });
	    return _this;
	  }
	
	  MoleculeIcon.prototype._initAnimations = function _initAnimations() {
	    var _this2 = this;
	
	    this._motionPaths.forEach(function (mp, i) {
	      var pathData = mp.getAttribute('d');
	
	      var index1 = i * 2;
	      var index2 = i * 2 + 1;
	      var atoms = [_this2._atoms[index1], _this2._atoms[index2]];
	
	      var bezierData = MorphSVGPlugin.pathDataToBezier(pathData, { align: atoms });
	
	      TweenMax.set(atoms, {
	        xPercent: -50,
	        yPercent: -50,
	        opacity: 1,
	        bezier: {
	          values: bezierData,
	          type: 'cubic'
	        }
	      });
	
	      _lodash2.default.times(NUM_ATOMS_PER_RING, function (j) {
	        TweenMax.to(atoms[j], ANIM_DURATION, {
	          bezier: {
	            values: bezierData,
	            type: 'cubic'
	          },
	          ease: Linear.easeNone,
	          repeat: -1,
	          yoyo: false,
	          delay: ANIM_DURATION * 0.5 * j + index1 * 0.2
	        });
	      });
	    });
	  };
	
	  MoleculeIcon.prototype.componentDidMount = function componentDidMount() {
	    this._initAnimations();
	  };
	
	  MoleculeIcon.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        centerColor = _props.centerColor,
	        electronColor = _props.electronColor,
	        ringColor = _props.ringColor,
	        width = _props.width,
	        height = _props.height;
	
	
	    return _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 100 100', width: width, height: height },
	      _react2.default.createElement(
	        'g',
	        { ref: function ref(icon) {
	            _this3._icon = icon;
	          } },
	        _react2.default.createElement('circle', {
	          ref: function ref(center) {
	            _this3._center = center;
	          },
	          r: 3,
	          cx: 50,
	          cy: 50,
	          fill: centerColor })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _lodash2.default.times(NUM_RINGS, function (i) {
	          return _react2.default.createElement('path', {
	            key: 'motion-path-' + i,
	            style: {
	              transform: 'rotate(' + i * 180 / NUM_RINGS + 'deg)',
	              transformOrigin: '50% 50%'
	            },
	            ref: function ref(motionPath) {
	              _this3._motionPaths[i] = motionPath;
	            },
	            d: 'M 5 50 c 5 -20, 95 -20, 90 0 s -90 20, -90 0',
	            fill: 'none',
	            opacity: 0.2,
	            stroke: ringColor,
	            strokeWidth: 1 });
	        })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _lodash2.default.times(NUM_RINGS, function (i) {
	          return _react2.default.createElement(
	            'g',
	            { key: 'atom-ring-' + i, transform: 'rotate(' + i * 180 / NUM_RINGS + ', 50, 50)' },
	            _lodash2.default.times(NUM_ATOMS_PER_RING, function (j) {
	              return _react2.default.createElement('circle', {
	                key: 'atom-' + i + '__' + j,
	                style: { opacity: 0 },
	                ref: function ref(atom) {
	                  _this3._atoms[i * NUM_ATOMS_PER_RING + j] = atom;
	                },
	                r: 2,
	                cx: 5,
	                cy: 50,
	                fill: electronColor });
	            })
	          );
	        })
	      )
	    );
	  };
	
	  return MoleculeIcon;
	}(_react2.default.Component);
	
	;
	
	MoleculeIcon.propTypes = {
	  centerColor: _propTypes2.default.string,
	  electronColor: _propTypes2.default.string,
	  ringColor: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	MoleculeIcon.defaultProps = {
	  centerColor: 'black',
	  electronColor: 'black',
	  ringColor: 'black',
	  width: 200,
	  height: 200
	};
	
	exports.default = MoleculeIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _IconPaths = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Paths
	
	
	var ANIM_DURATION = 0.4;
	
	var MunchIcon = function (_React$Component) {
	  _inherits(MunchIcon, _React$Component);
	
	  function MunchIcon(props) {
	    _classCallCheck(this, MunchIcon);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._icon = null;
	    _this._motionPaths = [null, null, null];
	    _this._food = [null, null, null];
	    return _this;
	  }
	
	  MunchIcon.prototype._initAnimations = function _initAnimations() {
	    var _this2 = this;
	
	    var topLip = this._icon.querySelector('#lip-top');
	    var bottomLip = this._icon.querySelector('#lip-bottom');
	    var leftCheek = this._icon.querySelector('#cheek-left');
	    var rightCheek = this._icon.querySelector('#cheek-right');
	
	    var mouseClosedData = this._icon.querySelector('#mouth-closed').getAttribute('d');
	    var leftCheekMunchData = this._icon.querySelector('#cheek-left-a').getAttribute('d');
	    var rightCheekMunchData = this._icon.querySelector('#cheek-right-a').getAttribute('d');
	
	    this._motionPaths[0] = this._icon.querySelector('#motion-path-1').getAttribute('d');
	    this._motionPaths[1] = this._icon.querySelector('#motion-path-2').getAttribute('d');
	
	    TweenMax.to(topLip, ANIM_DURATION, {
	      morphSVG: mouseClosedData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    TweenMax.to(bottomLip, ANIM_DURATION, {
	      morphSVG: mouseClosedData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    TweenMax.to(leftCheek, ANIM_DURATION, {
	      morphSVG: leftCheekMunchData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    TweenMax.to(rightCheek, ANIM_DURATION, {
	      morphSVG: rightCheekMunchData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    _lodash2.default.times(2, function (i) {
	      var bezierData = MorphSVGPlugin.pathDataToBezier(_this2._motionPaths[i], {
	        align: _this2._food[i]
	      });
	      TweenMax.set(_this2._food[i], { xPercent: -50, yPercent: -50 });
	      TweenMax.to(_this2._food[i], ANIM_DURATION * 2, {
	        scale: 0.5,
	        bezier: {
	          values: bezierData,
	          type: 'cubic'
	        },
	        ease: Linear.easeNone,
	        repeat: -1,
	        yoyo: false,
	        delay: 0.1 * i
	      });
	    });
	  };
	
	  MunchIcon.prototype.componentDidMount = function componentDidMount() {
	    this._initAnimations();
	  };
	
	  MunchIcon.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        foodColor = _props.foodColor,
	        strokeColor = _props.strokeColor,
	        width = _props.width,
	        height = _props.height;
	
	
	    return _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 100 100', width: width, height: height },
	      _react2.default.createElement(
	        'g',
	        { ref: function ref(icon) {
	            _this3._icon = icon;
	          } },
	        _react2.default.createElement(_IconPaths.Munch, { transform: 'translate(0, 0)', strokeColor: strokeColor })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('circle', { ref: function ref(food) {
	            _this3._food[0] = food;
	          }, r: 3, cx: 70, cy: 100, fill: 'none', stroke: foodColor, strokeWidth: 2 }),
	        _react2.default.createElement('circle', { ref: function ref(food) {
	            _this3._food[1] = food;
	          }, r: 2, cx: 70, cy: 100, fill: 'none', stroke: foodColor, strokeWidth: 2 })
	      )
	    );
	  };
	
	  return MunchIcon;
	}(_react2.default.Component);
	
	;
	
	MunchIcon.propTypes = {
	  foodColor: _propTypes2.default.string,
	  strokeColor: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	MunchIcon.defaultProps = {
	  foodColor: 'black',
	  strokeColor: 'black',
	  width: 200,
	  height: 200
	};
	
	exports.default = MunchIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _IconPaths = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Paths
	
	
	var DEBUG = false;
	
	var PodiumIcon = function (_React$Component) {
	  _inherits(PodiumIcon, _React$Component);
	
	  function PodiumIcon(props) {
	    _classCallCheck(this, PodiumIcon);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._icon = null;
	    return _this;
	  }
	
	  PodiumIcon.prototype._initAnimations = function _initAnimations() {
	
	    var circle1 = this._icon.querySelector('#podium-circle-1');
	    var circle2 = this._icon.querySelector('#podium-circle-2');
	    var circle3 = this._icon.querySelector('#podium-circle-3');
	
	    var rect1 = this._icon.querySelector('#podium-rect-1');
	    var rect2 = this._icon.querySelector('#podium-rect-2');
	    var rect3 = this._icon.querySelector('#podium-rect-3');
	
	    var rect1EndData = this._icon.querySelector('#podium-rect-1a').getAttribute('d');
	    var rect2EndData = this._icon.querySelector('#podium-rect-2a').getAttribute('d');
	    var rect3EndData = this._icon.querySelector('#podium-rect-3a').getAttribute('d');
	
	    TweenMax.to(rect1, 0.5, {
	      morphSVG: rect1EndData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true,
	      delay: 0.5
	    });
	
	    TweenMax.to(rect2, 0.5, {
	      morphSVG: rect2EndData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true,
	      delay: 0.5
	    });
	
	    TweenMax.to(rect3, 0.5, {
	      morphSVG: rect3EndData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true,
	      delay: 0.5
	    });
	
	    TweenMax.set(circle1, { scaleY: 0.9, y: 3 });
	    TweenMax.to(circle1, 0.5, {
	      y: -10,
	      scaleY: 1,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    TweenMax.set(circle2, { scaleY: 0.85, y: 0 });
	    TweenMax.to(circle2, 0.5, {
	      y: -20,
	      scaleY: 1,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    TweenMax.set(circle3, { scaleY: 0.9, y: 4 });
	    TweenMax.to(circle3, 0.5, {
	      y: -5,
	      scaleY: 1,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	  };
	
	  PodiumIcon.prototype.componentDidMount = function componentDidMount() {
	    this._initAnimations();
	  };
	
	  PodiumIcon.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        colors = _props.colors,
	        height = _props.height,
	        width = _props.width,
	        nodeColors = _props.nodeColors,
	        strokeColor = _props.strokeColor;
	
	    var baseIconColor = colors.length > 1 ? colors[1] : colors[0];
	
	    return _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 100 100', width: width, height: height },
	      _react2.default.createElement(
	        'g',
	        { ref: function ref(icon) {
	            _this2._icon = icon;
	          } },
	        _react2.default.createElement(_IconPaths.Podium, { transform: 'translate(0, 0)', fill: baseIconColor, nodeColors: nodeColors, strokeColor: strokeColor })
	      )
	    );
	  };
	
	  return PodiumIcon;
	}(_react2.default.Component);
	
	;
	
	PodiumIcon.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  nodeColors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  strokeColor: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	PodiumIcon.defaultProps = {
	  colors: ['black'],
	  nodeColors: ['black', 'black', 'black'],
	  strokeColor: 'white',
	  width: 200,
	  height: 200
	};
	
	exports.default = PodiumIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PodiumIcon = exports.MunchIcon = exports.MoleculeIcon = exports.HeartIcon = exports.FlaskIcon = undefined;
	
	var _FlaskIcon = __webpack_require__(64);
	
	var _FlaskIcon2 = _interopRequireDefault(_FlaskIcon);
	
	var _HeartIcon = __webpack_require__(65);
	
	var _HeartIcon2 = _interopRequireDefault(_HeartIcon);
	
	var _MunchIcon = __webpack_require__(67);
	
	var _MunchIcon2 = _interopRequireDefault(_MunchIcon);
	
	var _PodiumIcon = __webpack_require__(68);
	
	var _PodiumIcon2 = _interopRequireDefault(_PodiumIcon);
	
	var _MoleculeIcon = __webpack_require__(66);
	
	var _MoleculeIcon2 = _interopRequireDefault(_MoleculeIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.FlaskIcon = _FlaskIcon2.default;
	exports.HeartIcon = _HeartIcon2.default;
	exports.MoleculeIcon = _MoleculeIcon2.default;
	exports.MunchIcon = _MunchIcon2.default;
	exports.PodiumIcon = _PodiumIcon2.default;

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(17);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Search = __webpack_require__(78);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Logo = __webpack_require__(37);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _HeaderStyles = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var light = _ref.light;
	  return _react2.default.createElement(
	    _HeaderStyles.StyledHeader,
	    null,
	    !light && _react2.default.createElement(
	      _HeaderStyles.HeadingWrap,
	      null,
	      _react2.default.createElement(
	        _HeaderStyles.Heading,
	        null,
	        _react2.default.createElement(_Logo2.default, { size: 32 }),
	        'toomanykiwis'
	      ),
	      _react2.default.createElement(
	        _HeaderStyles.TagLine,
	        null,
	        _config2.default.TAG_LINE
	      )
	    ),
	    _react2.default.createElement(_Search2.default, null)
	  );
	};
	
	// Components
	
	
	Header.propsTypes = {
	  light: _propTypes2.default.bool
	};
	
	Header.defaultProps = {
	  light: true
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HeadingWrap = exports.TagLine = exports.Heading = exports.StyledHeader = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  padding: 1rem 2rem;\n  position: relative;\n'], ['\n  width: 100%;\n  padding: 1rem 2rem;\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n  font-size: 4rem;\n\n  > span {\n    font-size: 2rem;\n    position: relative;\n    top: 6px;\n    left: 1px;\n  }\n\n  > div {\n    margin: 0 8px 0 0;\n    display: inline-block;\n    position: relative;\n\n    > svg {\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n  }\n'], ['\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n  font-size: 4rem;\n\n  > span {\n    font-size: 2rem;\n    position: relative;\n    top: 6px;\n    left: 1px;\n  }\n\n  > div {\n    margin: 0 8px 0 0;\n    display: inline-block;\n    position: relative;\n\n    > svg {\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 0 0 0 3.9rem;\n'], ['\n  margin: 0 0 0 3.9rem;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding: 1rem 0 2rem;\n'], ['\n  padding: 1rem 0 2rem;\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledHeader = exports.StyledHeader = _styledComponents2.default.header(_templateObject);
	
	var Heading = exports.Heading = _styledComponents2.default.h1(_templateObject2);
	
	var TagLine = exports.TagLine = _styledComponents2.default.p(_templateObject3);
	
	var HeadingWrap = exports.HeadingWrap = _styledComponents2.default.hgroup(_templateObject4);

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(43);
	
	var _Header2 = _interopRequireDefault(_Header);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Header2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var icons = {
	  digestion: 'M78,70H20a12,12,0,0,1,0-24h1.06A12,12,0,0,1,30,26H68a2,2,0,0,1,0,4H30a8,8,0,0,0,0,16H80a2,2,0,0,1,0,4H20a8,8,0,0,0,0,16H78a2,2,0,0,1,0,4Z"/><path d="M50,30A12,12,0,0,1,38,18V12a2,2,0,0,1,4,0v6a8,8,0,0,0,8,8,2,2,0,0,1,0,4Z"/><path d="M50,90a2,2,0,0,1-2-2A12,12,0,0,1,60,76H80a8,8,0,0,0,0-16H20a2,2,0,0,1,0-4H80a8,8,0,0,0,0-16H30a2,2,0,0,1,0-4H70a8,8,0,0,0,0-16H54.23A6.24,6.24,0,0,1,48,13.77V12a2,2,0,0,1,4,0v1.77A2.23,2.23,0,0,0,54.23,16H70a12,12,0,0,1,8.94,20H80a12,12,0,0,1,6.63,22A12,12,0,0,1,80,80H60a8,8,0,0,0-8,8A2,2,0,0,1,50,90Z"/><path d="M40,90a2,2,0,0,1-2-2V78A12,12,0,0,1,50,66h1a2,2,0,0,1,0,4H50a8,8,0,0,0-8,8V88A2,2,0,0,1,40,90Z'
	};
	
	var Icon = function Icon(_ref) {
	  var icon = _ref.icon,
	      size = _ref.size;
	  return _react2.default.createElement(
	    'svg',
	    { width: size, height: size, viewBox: '0 0 1024 1024' },
	    _react2.default.createElement('path', { d: icons[icon] })
	  );
	};
	
	Icon.propTypes = {
	  icon: _propTypes2.default.string.isRequired,
	  size: _propTypes2.default.number
	};
	
	Icon.defaultProps = {
	  size: 128
	};
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Icon = __webpack_require__(132);
	
	var _Icon2 = _interopRequireDefault(_Icon);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Icon2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LeaderboardItem = __webpack_require__(77);
	
	var _LeaderboardItem2 = _interopRequireDefault(_LeaderboardItem);
	
	var _materialUiIcons = __webpack_require__(60);
	
	var _utils = __webpack_require__(18);
	
	var _LeaderboardStyles = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Icons
	
	
	// Utils
	
	
	// Styles
	
	
	var Leaderboard = function (_React$Component) {
	  _inherits(Leaderboard, _React$Component);
	
	  function Leaderboard(props) {
	    _classCallCheck(this, Leaderboard);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      descriptionExpanded: false,
	      listCollapsed: true
	    };
	    _this._handleMoreTapped = _this._handleMoreTapped.bind(_this);
	    _this._handleExpandDescriptionTapped = _this._handleExpandDescriptionTapped.bind(_this);
	    return _this;
	  }
	
	  Leaderboard.prototype._handleMoreTapped = function _handleMoreTapped() {
	    this.setState({
	      listCollapsed: !this.state.listCollapsed
	    });
	  };
	
	  Leaderboard.prototype._handleExpandDescriptionTapped = function _handleExpandDescriptionTapped() {
	    this.setState({
	      descriptionExpanded: !this.state.descriptionExpanded
	    });
	  };
	
	  Leaderboard.prototype.render = function render() {
	    var _state = this.state,
	        listCollapsed = _state.listCollapsed,
	        descriptionExpanded = _state.descriptionExpanded;
	    var _props = this.props,
	        collapseAfter = _props.collapseAfter,
	        items = _props.items,
	        split = _props.split,
	        title = _props.title,
	        description = _props.description;
	
	    return _react2.default.createElement(
	      _LeaderboardStyles.Wrapper,
	      { className: split ? '--split' : '' },
	      _react2.default.createElement(
	        _LeaderboardStyles.LeaderboardWrapper,
	        null,
	        _react2.default.createElement(
	          _LeaderboardStyles.Header,
	          null,
	          title,
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { title: 'Click to read a description of this list', onClick: this._handleExpandDescriptionTapped },
	            _react2.default.createElement(_materialUiIcons.HelpOutline, { style: { color: 'inherit', width: 20, height: 20 } })
	          )
	        ),
	        _react2.default.createElement(
	          _LeaderboardStyles.Description,
	          { show: descriptionExpanded },
	          description
	        ),
	        _react2.default.createElement(
	          _LeaderboardStyles.List,
	          null,
	          items.map(function (item, i) {
	            return (!listCollapsed || i < collapseAfter) && _react2.default.createElement(_LeaderboardItem2.default, {
	              key: 'leaderboard-item-' + i,
	              index: i + 1,
	              title: item.title,
	              meta: item.meta,
	              slug: (0, _utils.createSlugFromTitle)(item.title) });
	          }),
	          collapseAfter < items.length && _react2.default.createElement(
	            _LeaderboardStyles.Expander,
	            { onClick: this._handleMoreTapped },
	            listCollapsed ? 'More' : 'Less'
	          )
	        )
	      )
	    );
	  };
	
	  return Leaderboard;
	}(_react2.default.Component);
	
	;
	
	Leaderboard.propTypes = {
	  items: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string,
	  collapseAfter: _propTypes2.default.number,
	  split: _propTypes2.default.bool
	};
	
	Leaderboard.defaultProps = {
	  collapseAfter: 10,
	  description: '',
	  split: false
	};
	
	exports.default = Leaderboard;
	module.exports = exports['default'];

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Expander = exports.List = exports.Description = exports.Header = exports.LeaderboardWrapper = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  text-align: left;\n\n  &.--split {\n    ', '\n    ', '\n    ', '\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  text-align: left;\n\n  &.--split {\n    ', '\n    ', '\n    ', '\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['width: 50%;'], ['width: 50%;']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['width: 25%;'], ['width: 25%;']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['width: 20%;'], ['width: 20%;']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin: 1rem;\n  border-radius: 5px;\n  overflow: hidden;\n'], ['\n  margin: 1rem;\n  border-radius: 5px;\n  overflow: hidden;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  margin: 0;\n  padding: 3.2rem 15px 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n\n  > a {\n    position: absolute;\n    top: 3rem;\n    right: 0.5rem;\n    opacity: 0.2;\n    cursor: pointer;\n    display: none;\n    ', '\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n'], ['\n  width: 100%;\n  margin: 0;\n  padding: 3.2rem 15px 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n\n  > a {\n    position: absolute;\n    top: 3rem;\n    right: 0.5rem;\n    opacity: 0.2;\n    cursor: pointer;\n    display: none;\n    ', '\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['display: inline-block;'], ['display: inline-block;']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n\n  display: block;\n  ', '\n  padding: 0 1.5rem 1rem;\n  font-size: 1.4rem;\n'], ['\n\n  display: block;\n  ', '\n  padding: 0 1.5rem 1rem;\n  font-size: 1.4rem;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['display: ', ';'], ['display: ', ';']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  border-left: 1px solid rgba(0, 0, 0, 0.85);\n'], ['\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  border-left: 1px solid rgba(0, 0, 0, 0.85);\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 40px;\n  padding: 5px 50px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n'], ['\n  width: 100%;\n  height: 40px;\n  padding: 5px 50px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject, _styleUtils.media.fromSmall(_templateObject2), _styleUtils.media.fromLarge(_templateObject3), _styleUtils.media.fromXLarge(_templateObject4));
	
	var LeaderboardWrapper = exports.LeaderboardWrapper = _styledComponents2.default.div(_templateObject5);
	
	var Header = exports.Header = _styledComponents2.default.h2(_templateObject6, _styleUtils.media.fromSmall(_templateObject7));
	
	var Description = exports.Description = _styledComponents2.default.p(_templateObject8, _styleUtils.media.fromSmall(_templateObject9, function (props) {
	  return props.show ? 'block' : 'none';
	}));
	
	var List = exports.List = _styledComponents2.default.ul(_templateObject10);
	
	var Expander = exports.Expander = _styledComponents2.default.a(_templateObject11);

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Leaderboard = __webpack_require__(72);
	
	var _Leaderboard2 = _interopRequireDefault(_Leaderboard);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Leaderboard2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LeaderboardItemStyles = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeaderboardItem = function LeaderboardItem(_ref) {
	  var index = _ref.index,
	      meta = _ref.meta,
	      slug = _ref.slug,
	      title = _ref.title;
	  return _react2.default.createElement(
	    _LeaderboardItemStyles.Wrapper,
	    null,
	    _react2.default.createElement(
	      _LeaderboardItemStyles.Index,
	      null,
	      index
	    ),
	    _react2.default.createElement(
	      _LeaderboardItemStyles.Label,
	      null,
	      slug ? _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' + slug + '/' },
	        title
	      ) : title,
	      meta && _react2.default.createElement(
	        _LeaderboardItemStyles.Meta,
	        null,
	        meta
	      )
	    )
	  );
	};
	
	// Styles
	
	
	LeaderboardItem.propTypes = {
	  index: _propTypes2.default.number.isRequired,
	  meta: _propTypes2.default.string,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string,
	  slug: _propTypes2.default.string
	};
	
	LeaderboardItem.defaultProps = {
	  description: '',
	  slug: '',
	  meta: null
	};
	
	exports.default = LeaderboardItem;
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Meta = exports.Label = exports.Index = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n'], ['\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 50px;\n  height: 100%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  width: 50px;\n  height: 100%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: inline-flex;\n  width: 100%;\n  padding: 5px;\n  height: 100%;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n'], ['\n  display: inline-flex;\n  width: 100%;\n  padding: 5px;\n  height: 100%;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  color: green;\n  position: absolute;\n  right: 0;\n'], ['\n  color: green;\n  position: absolute;\n  right: 0;\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.li(_templateObject);
	
	var Index = exports.Index = _styledComponents2.default.div(_templateObject2);
	
	var Label = exports.Label = _styledComponents2.default.div(_templateObject3);
	
	var Meta = exports.Meta = _styledComponents2.default.span(_templateObject4);

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LeaderboardItem = __webpack_require__(75);
	
	var _LeaderboardItem2 = _interopRequireDefault(_LeaderboardItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _LeaderboardItem2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _rda = __webpack_require__(751);
	
	var _rda2 = _interopRequireDefault(_rda);
	
	var _config = __webpack_require__(17);
	
	var _utils = __webpack_require__(18);
	
	var _NutrientStatsStyles = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Data
	
	
	// Config
	
	
	// Utils
	
	
	// Styles
	
	
	// todo - move to config
	var nutrientBlacklist = ['Water', 'Vitamin D (D2 + D3)', 'Vitamin A, IU', 'Fatty acids, total monounsaturated', 'Fatty acids, total polyunsaturated', 'Total lipid (fat)'];
	
	var isValidNutrient = function isValidNutrient(nutrientName) {
	  return nutrientBlacklist.indexOf(nutrientName) === -1;
	};
	
	var Bar = function Bar(_ref) {
	  var val = _ref.val;
	  return _react2.default.createElement(
	    _NutrientStatsStyles.BarWrapper,
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: { width: Math.min(val, 100) + '%' } },
	      _react2.default.createElement(
	        'span',
	        null,
	        val > 0 ? val.toFixed(2) : 0
	      )
	    )
	  );
	};
	
	var getBarViz = function getBarViz(perc) {
	  return perc > 0 ? _react2.default.createElement(Bar, { val: perc }) : '';
	};
	
	var getRDABar = function getRDABar(value, units, nutrientName) {
	  var rdaKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'f';
	
	
	  // we may be using a shorter key in the RDA config
	  var key = nutrientName in _rda2.default ? nutrientName : (0, _utils.getShortNutrientName)(nutrientName);
	  var rda = _rda2.default[key];
	  if (rda.units === units) {
	    var perc = 100 * value / rda[rdaKey];
	    return getBarViz(perc);
	  } else {
	    // different units
	    if (units === 'IU' && rda.units === 'µg') {
	      var _perc = 100 * (0, _utils.iuToMcg)(value, nutrientName) / rda[rdaKey];
	      return getBarViz(_perc);
	    } else {
	      console.log('No RDA conversion possible', key, units, rda.units);
	      return '?';
	    }
	  }
	};
	
	var hasRDAMatch = function hasRDAMatch(nutrientName) {
	  return (0, _utils.getShortNutrientName)(nutrientName) in _rda2.default;
	};
	
	var NutrientStats = function (_React$Component) {
	  _inherits(NutrientStats, _React$Component);
	
	  function NutrientStats(props) {
	    _classCallCheck(this, NutrientStats);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      activeKey: props.keys[0]
	    };
	
	    _this._onKeyTapped = _this._onKeyTapped.bind(_this);
	    return _this;
	  }
	
	  NutrientStats.prototype._onKeyTapped = function _onKeyTapped(e) {
	    var index = parseInt(e.target.getAttribute('data-index'));
	    this.setState({
	      activeKey: this.props.keys[index]
	    });
	  };
	
	  NutrientStats.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        allNutrients = _props.allNutrients,
	        keys = _props.keys,
	        data = _props.data,
	        serving = _props.serving;
	    var activeKey = this.state.activeKey;
	
	
	    var activeNutrients = data.filter(function (n) {
	      return isValidNutrient(n.name) && n.value > 0;
	    });
	    var inactiveNutrients = data.filter(function (n) {
	      return isValidNutrient(n.name) && Math.abs(n.value) === 0;
	    });
	
	    // console.table(activeNutrients);
	    // console.log('nutrientsThresholds', nutrientsThresholds, activeNutrients);
	
	    var groupedData = {
	      tiny: [],
	      some: [],
	      good: [],
	      lots: [],
	      other: []
	    };
	
	    activeNutrients.forEach(function (n) {
	      // const valuePerServing = n.value * (serving / 100);
	      var rdaKey = activeKey.key;
	      var nutrientName = (0, _utils.formatVitaminName)(n.name);
	      var key = nutrientName in _rda2.default ? nutrientName : (0, _utils.getShortNutrientName)(nutrientName);
	      var rda = _rda2.default[key];
	      var valuePer100g = n.value;
	      var valuePerServing = valuePer100g * (serving / 100);
	      var units = n.unit;
	      var perc = 0;
	
	      if (rda && rda.units === units) {
	        perc = 100 * valuePerServing / rda[rdaKey];
	      } else {
	        // different units
	        if (units === 'IU' && rda.units === 'µg') {
	          perc = 100 * (0, _utils.iuToMcg)(value, nutrientName) / rda[rdaKey];
	        } else {
	          console.log('no rda conversion possible', nutrientName, key);
	        }
	      }
	
	      var pathData = _lodash2.default.find(allNutrients, function (nutrient) {
	        return nutrient.name.toLowerCase() === key.toLowerCase();
	      }) || '';
	
	      if (perc < _config.nutrientsThresholds.some) {
	        groupedData.tiny.push(_extends({}, n, { pathData: pathData }));
	      } else if (perc < _config.nutrientsThresholds.good) {
	        groupedData.some.push(_extends({}, n, { pathData: pathData }));
	      } else if (perc < _config.nutrientsThresholds.lots) {
	        groupedData.good.push(_extends({}, n, { pathData: pathData }));
	      } else if (perc >= _config.nutrientsThresholds.lots) {
	        groupedData.lots.push(_extends({}, n, { pathData: pathData }));
	      } else {
	        groupedData.other.push(_extends({}, n, { pathData: pathData }));
	      }
	    });
	
	    var createNutrientsList = function createNutrientsList(nutrientsData) {
	      return _react2.default.createElement(
	        'ul',
	        null,
	        nutrientsData.filter(function (n) {
	          return isValidNutrient(n.name);
	        }).map(function (n, i) {
	          var nutrientName = (0, _utils.formatVitaminName)(n.name);
	          var valuePer100g = n.value;
	          var units = n.unit;
	          var path = n.pathData.path || '';
	          var valuePerServing = valuePer100g * (serving / 100);
	
	          return _react2.default.createElement(
	            _NutrientStatsStyles.NutrientListItem,
	            { key: n.nutrient_id, serving: serving },
	            _react2.default.createElement(
	              'span',
	              null,
	              path ? _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: path },
	                (0, _utils.getShortNutrientName)(nutrientName)
	              ) : (0, _utils.getShortNutrientName)(nutrientName)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-value': valuePerServing.toFixed(2) + n.unit },
	              hasRDAMatch(nutrientName) ? getRDABar(valuePerServing, n.unit, nutrientName, activeKey.key) : _react2.default.createElement(
	                _NutrientStatsStyles.BarWrapper,
	                null,
	                _react2.default.createElement('div', null)
	              )
	            )
	          );
	        })
	      );
	    };
	
	    return _react2.default.createElement(
	      _NutrientStatsStyles.Wrapper,
	      null,
	      _react2.default.createElement(
	        _NutrientStatsStyles.NutrientsNav,
	        null,
	        keys.map(function (k, i) {
	          return _react2.default.createElement(
	            'a',
	            { title: k.label + ' (Recommended Daily Allowance)', 'data-active': activeKey.key === k.key, key: k.key, onClick: _this2._onKeyTapped, 'data-index': i },
	            k.label
	          );
	        })
	      ),
	      groupedData.lots.length ? _react2.default.createElement(
	        _NutrientStatsStyles.StatsSection,
	        null,
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Loads of...'
	        ),
	        createNutrientsList(groupedData.lots)
	      ) : '',
	      groupedData.good.length ? _react2.default.createElement(
	        _NutrientStatsStyles.StatsSection,
	        null,
	        _react2.default.createElement(
	          'h4',
	          null,
	          'A good amount of...'
	        ),
	        createNutrientsList(groupedData.good)
	      ) : '',
	      groupedData.some.length ? _react2.default.createElement(
	        _NutrientStatsStyles.StatsSection,
	        null,
	        _react2.default.createElement(
	          'h4',
	          null,
	          'A small amount of...'
	        ),
	        createNutrientsList(groupedData.some)
	      ) : '',
	      groupedData.tiny.length ? _react2.default.createElement(
	        _NutrientStatsStyles.StatsSection,
	        null,
	        _react2.default.createElement(
	          'h4',
	          null,
	          'A tiny amount of'
	        ),
	        createNutrientsList(groupedData.tiny)
	      ) : '',
	      _react2.default.createElement(
	        _NutrientStatsStyles.AbsentNutrientsWrapper,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Absent Nutrients: ',
	          inactiveNutrients.map(function (n) {
	            return (0, _utils.formatVitaminName)((0, _utils.getShortNutrientName)(n.name));
	          }).join(', ')
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Recommended Daily Allowance (RDA) % shown for adult ',
	          activeKey.label.toLowerCase(),
	          ', as published by the ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.nhs.uk/conditions/vitamins-and-minerals/', target: '_blank' },
	            'NHS (UK)'
	          ),
	          '.'
	        )
	      )
	    );
	  };
	
	  return NutrientStats;
	}(_react2.default.Component);
	
	NutrientStats.propTypes = {
	  allNutrients: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    path: _propTypes2.default.string.isRequired
	  })).isRequired,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  keys: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    label: _propTypes2.default.string.isRequired,
	    key: _propTypes2.default.string.isRequired
	  })).isRequired,
	  serving: _propTypes2.default.number.isRequired
	};
	
	exports.default = NutrientStats;
	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BarWrapper = exports.StatsSection = exports.NutrientsNav = exports.NutrientListItem = exports.AbsentNutrientsWrapper = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 1rem 0;\n  > p {\n    font-size: 1.2rem;\n  }\n'], ['\n  margin: 1rem 0;\n  > p {\n    font-size: 1.2rem;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  height: 2rem;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  white-space: nowrap;\n\n  > span {\n    display: inline-block;\n    position: relative;\n    width: 70%;\n\n    &:first-child {\n      text-align: right;\n      width: 100px;\n      padding-right: 1rem;\n    }\n\n    &:nth-child(2) {\n      background: rgba(255, 255, 255, 0.05);\n\n      &::after {\n        content: attr(data-value);\n        width: 50px;\n        height: 100%;\n        position: absolute;\n        right: 0;\n        top: 0;\n        font-size: 1.2rem;\n        opacity: 0.7;\n      }\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.15);\n\n        &::after {\n          opacity: 1;\n        }\n      }\n    }\n\n\n  }\n'], ['\n  height: 2rem;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  white-space: nowrap;\n\n  > span {\n    display: inline-block;\n    position: relative;\n    width: 70%;\n\n    &:first-child {\n      text-align: right;\n      width: 100px;\n      padding-right: 1rem;\n    }\n\n    &:nth-child(2) {\n      background: rgba(255, 255, 255, 0.05);\n\n      &::after {\n        content: attr(data-value);\n        width: 50px;\n        height: 100%;\n        position: absolute;\n        right: 0;\n        top: 0;\n        font-size: 1.2rem;\n        opacity: 0.7;\n      }\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.15);\n\n        &::after {\n          opacity: 1;\n        }\n      }\n    }\n\n\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding: 1rem 0;\n  text-align: center;\n\n  > a {\n    padding: 1rem;\n    cursor: pointer;\n    opacity: 0.85;\n    user-select: none;\n\n    &[data-active="true"] {\n      text-decoration: underline;\n      opacity: 1;\n    }\n  }\n'], ['\n  padding: 1rem 0;\n  text-align: center;\n\n  > a {\n    padding: 1rem;\n    cursor: pointer;\n    opacity: 0.85;\n    user-select: none;\n\n    &[data-active="true"] {\n      text-decoration: underline;\n      opacity: 1;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n\n  margin: 0 0 3rem 0;\n\n  > h4 {\n    padding: 0 0 0 100px;\n    margin: 1rem 0 2rem;\n  }\n'], ['\n\n  margin: 0 0 3rem 0;\n\n  > h4 {\n    padding: 0 0 0 100px;\n    margin: 1rem 0 2rem;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  height: 16px;\n  width: 70%;\n  padding: 0 20px 0 0;\n\n  > div {\n    display: inline-block;\n    height: 14px;\n    background: rgba(255, 255, 255, 0.85);\n    position: relative;\n\n    > span {\n      position: absolute;\n      right: -55px;\n      top: -2px;\n      width: 50px;\n      font-size: 1.2rem;\n\n      &:after {\n        content: \'%\';\n        opacity: 0.5;\n      }\n\n    }\n  }\n'], ['\n  height: 16px;\n  width: 70%;\n  padding: 0 20px 0 0;\n\n  > div {\n    display: inline-block;\n    height: 14px;\n    background: rgba(255, 255, 255, 0.85);\n    position: relative;\n\n    > span {\n      position: absolute;\n      right: -55px;\n      top: -2px;\n      width: 50px;\n      font-size: 1.2rem;\n\n      &:after {\n        content: \'%\';\n        opacity: 0.5;\n      }\n\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject);
	
	var AbsentNutrientsWrapper = exports.AbsentNutrientsWrapper = _styledComponents2.default.div(_templateObject2);
	
	var NutrientListItem = exports.NutrientListItem = _styledComponents2.default.div(_templateObject3);
	
	var NutrientsNav = exports.NutrientsNav = _styledComponents2.default.nav(_templateObject4);
	
	var StatsSection = exports.StatsSection = _styledComponents2.default.section(_templateObject5);
	
	var BarWrapper = exports.BarWrapper = _styledComponents2.default.div(_templateObject6);

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NutrientStats = __webpack_require__(301);
	
	var _NutrientStats2 = _interopRequireDefault(_NutrientStats);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _NutrientStats2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(18);
	
	var _Icon = __webpack_require__(133);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Logo = __webpack_require__(37);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AnimatedIcons = __webpack_require__(41);
	
	var _ResearchCardStyles = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var createLinks = function createLinks(links) {
	  return links.map(function (link, i) {
	    return (/http/.test(link) ? _react2.default.createElement(
	        'span',
	        { key: 'link-' + i },
	        _react2.default.createElement(
	          'a',
	          { href: link, target: '_blank' },
	          '[',
	          i + 1,
	          ']'
	        ),
	        ' '
	      ) : ''
	    );
	  });
	};
	
	// Styles
	
	
	// Utils
	
	
	var ResearchCard = function ResearchCard(_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      heading = _ref.heading,
	      link1 = _ref.link1,
	      link2 = _ref.link2,
	      link3 = _ref.link3,
	      prevents = _ref.prevents,
	      reliability = _ref.reliability;
	
	  var baseColor = content.themecolor || 'rgb(0, 0, 0)';
	  var themeColors = baseColor.split('-');
	  var textColor = content.textcolor || 'rgb(255, 255, 255)';
	
	  return _react2.default.createElement(
	    _ResearchCardStyles.ResearchCardWrapper,
	    null,
	    _react2.default.createElement(
	      _ResearchCardStyles.FoodSection,
	      null,
	      _react2.default.createElement(_AnimatedIcons.FlaskIcon, { width: 120, height: 120, type: 'flask', colors: themeColors }),
	      _react2.default.createElement(
	        _ResearchCardStyles.StyledFoodName,
	        { themeColors: themeColors, textColor: textColor },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' + (0, _utils.createSlugFromTitle)(title) + '/' },
	          title
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _ResearchCardStyles.ResultsSection,
	      null,
	      _react2.default.createElement(
	        _ResearchCardStyles.StyledIntroHeading,
	        null,
	        heading
	      ),
	      _react2.default.createElement(
	        _ResearchCardStyles.StyledPreventsHeading,
	        { themeColors: themeColors, textColor: textColor },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' + (0, _utils.createSlugFromTitle)(title) + '/' },
	          prevents
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Reliability: ',
	        reliability,
	        '. ',
	        createLinks([link1, link2, link3])
	      ),
	      _react2.default.createElement(_ResearchCardStyles.Links, null)
	    )
	  );
	};
	
	ResearchCard.propTypes = {
	  content: _propTypes2.default.object.isRequired,
	  reliability: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  heading: _propTypes2.default.string.isRequired,
	  prevents: _propTypes2.default.string.isRequired,
	  link1: _propTypes2.default.string,
	  link2: _propTypes2.default.string,
	  link3: _propTypes2.default.string
	};
	
	ResearchCard.defaultProps = {
	  link1: null,
	  link2: null,
	  link3: null
	};
	
	exports.default = ResearchCard;
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Links = exports.StyledPreventsHeading = exports.StyledIntroHeading = exports.StyledFoodName = exports.ResultsSection = exports.FoodSection = exports.LogoWrapper = exports.ResearchCardWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n'], ['\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  margin: 6rem 0 4rem;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  .logo {\n    animation: ', ' 12s linear infinite forwards;\n  }\n'], ['\n  width: 100%;\n  margin: 6rem 0 4rem;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  .logo {\n    animation: ', ' 12s linear infinite forwards;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  left: 50%;\n  top: -20px;\n  width: 40px;\n  height: 40px;\n  margin: 0 0 0 -20px;\n  z-index: 1;\n'], ['\n  position: absolute;\n  left: 50%;\n  top: -20px;\n  width: 40px;\n  height: 40px;\n  margin: 0 0 0 -20px;\n  z-index: 1;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  a {\n    text-decoration: none;\n  }\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  a {\n    text-decoration: none;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding: 1rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n'], ['\n  padding: 1rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  font-size: 2rem;\n  ', '\n  text-align: right;\n  margin: 0;\n\n  > a {\n    display: block;\n    padding: 1rem;\n    color: inherit;\n    position: relative;\n    z-index: 2;\n    background: ', ';\n    color: ', ';\n  }\n'], ['\n  font-size: 2rem;\n  ', '\n  text-align: right;\n  margin: 0;\n\n  > a {\n    display: block;\n    padding: 1rem;\n    color: inherit;\n    position: relative;\n    z-index: 2;\n    background: ', ';\n    color: ', ';\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['font-size: 3rem;'], ['font-size: 3rem;']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  margin: 0.5rem auto;\n  font-size: 1.6rem;\n'], ['\n  margin: 0.5rem auto;\n  font-size: 1.6rem;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  font-size: 2rem;\n  ', '\n  margin: 1rem 0 1.1rem -0.2rem;\n  position: relative;\n\n  > a {\n    padding: 1rem;\n    display: block;\n    position: relative;\n    z-index: 2;\n    background: ', ';\n    color: ', ';\n    min-width: 200px;\n  }\n\n  &::after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    top: -70px;\n    height: 95px;\n    width: 120%;\n    margin: 0 0 0 -10%;\n    ', '\n    ', '\n    border: 1px solid ', ';\n    border-radius: 5px;\n    z-index: 1;\n  }\n'], ['\n  font-size: 2rem;\n  ', '\n  margin: 1rem 0 1.1rem -0.2rem;\n  position: relative;\n\n  > a {\n    padding: 1rem;\n    display: block;\n    position: relative;\n    z-index: 2;\n    background: ', ';\n    color: ', ';\n    min-width: 200px;\n  }\n\n  &::after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    top: -70px;\n    height: 95px;\n    width: 120%;\n    margin: 0 0 0 -10%;\n    ', '\n    ', '\n    border: 1px solid ', ';\n    border-radius: 5px;\n    z-index: 1;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n      width: 140%;\n      margin: 0 0 0 -20%;\n    '], ['\n      width: 140%;\n      margin: 0 0 0 -20%;\n    ']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n      width: 160%;\n      margin: 0 0 0 -30%;\n    '], ['\n      width: 160%;\n      margin: 0 0 0 -30%;\n    ']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  bottom: 1rem;\n  right: 2rem;\n'], ['\n  position: absolute;\n  bottom: 1rem;\n  right: 2rem;\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var spinLogoKeyframes = (0, _styledComponents.keyframes)(_templateObject);
	
	var ResearchCardWrapper = exports.ResearchCardWrapper = _styledComponents2.default.div(_templateObject2, spinLogoKeyframes);
	
	var LogoWrapper = exports.LogoWrapper = _styledComponents2.default.div(_templateObject3);
	
	var FoodSection = exports.FoodSection = _styledComponents2.default.div(_templateObject4);
	
	var ResultsSection = exports.ResultsSection = _styledComponents2.default.div(_templateObject5);
	
	var StyledFoodName = exports.StyledFoodName = _styledComponents2.default.h1(_templateObject6, _styleUtils.media.fromMedium(_templateObject7), function (props) {
	  return props.themeColors[0];
	}, function (props) {
	  return props.textColor;
	});
	
	var StyledIntroHeading = exports.StyledIntroHeading = _styledComponents2.default.h3(_templateObject8);
	
	var StyledPreventsHeading = exports.StyledPreventsHeading = _styledComponents2.default.h1(_templateObject9, _styleUtils.media.fromMedium(_templateObject7), function (props) {
	  return props.themeColors[0];
	}, function (props) {
	  return props.textColor;
	}, _styleUtils.media.fromMedium(_templateObject10), _styleUtils.media.fromLarge(_templateObject11), function (props) {
	  return _.takeRight(props.themeColors);
	});
	
	var Links = exports.Links = _styledComponents2.default.div(_templateObject12);

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ResearchCard = __webpack_require__(134);
	
	var _ResearchCard2 = _interopRequireDefault(_ResearchCard);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _ResearchCard2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UnfinishedBannerStyles = __webpack_require__(307);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnfinishedBanner = function UnfinishedBanner(_ref) {
	  var description = _ref.description,
	      title = _ref.title;
	  return _react2.default.createElement(
	    _UnfinishedBannerStyles.Wrapper,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      description
	    )
	  );
	};
	
	UnfinishedBanner.propTypes = {
	  description: _propTypes2.default.string,
	  title: _propTypes2.default.string
	};
	
	UnfinishedBanner.defaultProps = {
	  description: 'Thanks for stopping by. Just to let you know, the content for this page is not quite complete. Please check back in the next few weeks!',
	  title: 'This page is a work in progress'
	};
	
	exports.default = UnfinishedBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  padding: 3.5rem 2rem 3rem;\n  box-shadow: inset 0px 0px 52px rgba(0, 0, 0, 0.3);\n'], ['\n  text-align: center;\n  padding: 3.5rem 2rem 3rem;\n  box-shadow: inset 0px 0px 52px rgba(0, 0, 0, 0.3);\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject);

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _UnfinishedBanner = __webpack_require__(306);
	
	var _UnfinishedBanner2 = _interopRequireDefault(_UnfinishedBanner);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _UnfinishedBanner2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Components
	
	
	// Icons
	
	
	// Utils
	
	
	// Styles
	
	
	exports.default = Template;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(33);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(17);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Logo = __webpack_require__(37);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _ResearchCard = __webpack_require__(136);
	
	var _ResearchCard2 = _interopRequireDefault(_ResearchCard);
	
	var _Header = __webpack_require__(45);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _NutrientStats = __webpack_require__(303);
	
	var _NutrientStats2 = _interopRequireDefault(_NutrientStats);
	
	var _Leaderboard = __webpack_require__(74);
	
	var _Leaderboard2 = _interopRequireDefault(_Leaderboard);
	
	var _UnfinishedBanner = __webpack_require__(308);
	
	var _UnfinishedBanner2 = _interopRequireDefault(_UnfinishedBanner);
	
	var _AnimatedIcons = __webpack_require__(41);
	
	var _materialUiIcons = __webpack_require__(60);
	
	var _utils = __webpack_require__(18);
	
	var _FoodTemplateStyles = __webpack_require__(328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(props) {
	  var content = props.pathContext.content;
	  var allNutrients = props.pathContext.allNutrients;
	  var longTitle = (/[^u](s|fruit)+$/i.test(content.title) ? 'Are' : 'Is') + ' ' + content.title + ' good for you?';
	  var baseColor = content.themecolor || 'rgb(0, 0, 0)';
	  var themeColors = baseColor.split('-');
	  var textColor = content.textcolor || 'rgb(255, 255, 255)';
	  var serving = content.serving || 100;
	  var servingText = (0, _utils.formatServingText)(serving, content.servingtext, content.title);
	  var description = !/^Lorem/.test(content.description) && content.description;
	  var sourcing = !/^Lorem/.test(content.sourcing) && content.sourcing;
	  var featuredData = content.featuredData && content.featuredData.length ? content.featuredData : null;
	
	  var meta = {
	    title: 'Health benefits of ' + (0, _utils.getContinuousVerb)(content.verb) + ' ' + content.title,
	    description: longTitle + ' ' + (description ? description.substring(0, 180) : '')
	  };
	
	  var isWIP = !content.researchData || !content.researchData.length;
	
	  return _react2.default.createElement(
	    _FoodTemplateStyles.StyledWrapper,
	    { themeColors: themeColors, textColor: textColor },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        meta.title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: meta.description })
	    ),
	    _react2.default.createElement(_Header2.default, { themeColors: themeColors, backLink: true }),
	    _react2.default.createElement(
	      _FoodTemplateStyles.TopSection,
	      { id: '' + longTitle.toLowerCase().replace(/\s/g, '-').replace('?', '') },
	      _react2.default.createElement(
	        _FoodTemplateStyles.TitleSection,
	        null,
	        _react2.default.createElement(_AnimatedIcons.HeartIcon, {
	          width: 80,
	          height: 80,
	          color: textColor }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '#' + longTitle.toLowerCase().replace(/\s/g, '-').replace('?', '') },
	            _react2.default.createElement(_materialUiIcons.Link, { className: 'icon icon--link-prompt', style: { width: 24, height: 24 } }),
	            longTitle
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          description
	        ),
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement(
	            _FoodTemplateStyles.CardsSection,
	            { textColor: textColor },
	            content.tags.map(function (t) {
	              return _react2.default.createElement(_Card2.default, _extends({ id: t.tag, key: t.tag }, t));
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _FoodTemplateStyles.HomeLinkWrap,
	          { themeColors: themeColors, textColor: textColor },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            '\u2190 Home'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _FoodTemplateStyles.NutrientsSection,
	        { id: 'nutrients' },
	        _react2.default.createElement(
	          _FoodTemplateStyles.NutrientsHeader,
	          null,
	          _react2.default.createElement(_AnimatedIcons.MoleculeIcon, {
	            ringColor: textColor,
	            centerColor: textColor,
	            electronColor: textColor,
	            width: 80,
	            height: 80 }),
	          _react2.default.createElement(
	            'h1',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '#nutrients' },
	              _react2.default.createElement(_materialUiIcons.Link, { className: 'icon icon--link-prompt', style: { width: 24, height: 24 } }),
	              'Nutrients'
	            )
	          ),
	          _react2.default.createElement(
	            _FoodTemplateStyles.ServingText,
	            { serving: serving },
	            'Nutritional value in ',
	            servingText,
	            '...',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'i',
	              null,
	              '(% RDA in ',
	              serving,
	              'g)'
	            )
	          ),
	          serving < 10 && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'i',
	              null,
	              'Bear in mind, the bars below will be very small, because the serving is tiny.'
	            )
	          )
	        ),
	        content.nutrients && content.nutrients.length ? _react2.default.createElement(_NutrientStats2.default, {
	          keys: [{ label: 'Females', key: 'f' }, { label: 'Males', key: 'm' }], data: content.nutrients,
	          allNutrients: allNutrients,
	          serving: parseFloat(content.serving) || 100 }) : _react2.default.createElement(
	          _FoodTemplateStyles.MissingNutrientText,
	          { textColor: textColor },
	          'Sorry, the nutrient data for ',
	          content.title,
	          ' is currently missing. Please check back in the next couple of weeks.'
	        )
	      )
	    ),
	    isWIP && _react2.default.createElement(_UnfinishedBanner2.default, null),
	    _react2.default.createElement(
	      _FoodTemplateStyles.ResearchSection,
	      { id: (0, _utils.createSectionId)(content.title, 'research') },
	      _react2.default.createElement(
	        'h1',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '#' + (0, _utils.createSectionId)(content.title, 'research') },
	          _react2.default.createElement(_materialUiIcons.Link, { className: 'icon icon--link-prompt', style: { width: 24, height: 24 } }),
	          'Medical Research into ',
	          (0, _utils.getContinuousVerb)(content.verb),
	          ' ',
	          content.title
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        content.researchData && content.researchData.length ? content.researchData.map(function (node) {
	          return _react2.default.createElement(_ResearchCard2.default, _extends({
	            key: node.id
	          }, node, {
	            content: content }));
	        }) : _react2.default.createElement(
	          'p',
	          null,
	          'There is no research data yet, but this will be updated very soon! ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.google.co.uk/search?q=' + content.title.replace(' ', '+').toLowerCase() + '+medical+research', target: '_blank' },
	            'Check Google \u2192'
	          )
	        )
	      )
	    ),
	    featuredData && _react2.default.createElement(
	      _FoodTemplateStyles.LeaderboardsWrapper,
	      { textColor: textColor },
	      _react2.default.createElement(_AnimatedIcons.PodiumIcon, {
	        width: 120,
	        height: 120,
	        colors: [textColor],
	        nodeColors: [themeColors[0], themeColors[0], themeColors[0]],
	        strokeColor: textColor }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Lists Containing ',
	        content.title
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        featuredData.map(function (_ref) {
	          var id = _ref.id,
	              title = _ref.title,
	              description = _ref.description,
	              image = _ref.image,
	              items = _ref.items;
	          return _react2.default.createElement(_Leaderboard2.default, {
	            key: id,
	            image: image,
	            title: title,
	            description: description,
	            items: items,
	            split: true });
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _FoodTemplateStyles.TooMuchSection,
	      { id: (0, _utils.createSectionId)(content.title, 'too-much') },
	      _react2.default.createElement(
	        _FoodTemplateStyles.CenteredHeading,
	        null,
	        _react2.default.createElement(_AnimatedIcons.MunchIcon, {
	          width: 120,
	          height: 120,
	          strokeColor: 'black',
	          foodColor: themeColors[0] }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '#' + (0, _utils.createSectionId)(content.title, 'too-much') },
	            _react2.default.createElement(_materialUiIcons.Link, { className: 'icon icon--link-prompt', style: { width: 24, height: 24 } }),
	            'Can I ',
	            content.verb || 'eat',
	            ' too ',
	            (0, _utils.getDeterminer)(content.title),
	            ' ',
	            content.title,
	            '?'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        /^Lorem/.test(content.toomuchcauses) ? _config2.default.missingText.toomuchcauses : content.toomuchcauses
	      )
	    )
	  );
	};
	module.exports = exports['default'];

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BuySection = exports.TooMuchSection = exports.AbstractLogosSectionBottom = exports.AbstractLogosSectionTop = exports.ResearchSection = exports.CardsSection = exports.HomeLinkWrap = exports.ServingText = exports.MissingNutrientText = exports.NutrientsHeader = exports.NutrientsSection = exports.CenteredHeading = exports.TitleSection = exports.TopSection = exports.LeaderboardsWrapper = exports.StyledWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 0;\n  background: ', ';\n  color: ', ';\n\n  > section {\n    padding: 4rem 2rem;\n  }\n'], ['\n  padding: 0;\n  background: ', ';\n  color: ', ';\n\n  > section {\n    padding: 4rem 2rem;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 4rem 0 0;\n  text-align: center;\n\n  > h1 {\n    margin: 2rem 0;\n  }\n\n  > div {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 0 0 2rem 0;\n\n    ul {\n      border-left-color: ', ';\n    }\n  }\n\n'], ['\n  margin: 4rem 0 0;\n  text-align: center;\n\n  > h1 {\n    margin: 2rem 0;\n  }\n\n  > div {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 0 0 2rem 0;\n\n    ul {\n      border-left-color: ', ';\n    }\n  }\n\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding: 8rem 1rem;\n  margin: 5rem 0 4rem 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  ', '\n'], ['\n  padding: 8rem 1rem;\n  margin: 5rem 0 4rem 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  ', '\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['flex-direction: row;'], ['flex-direction: row;']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  ', '\n  ', '\n'], ['\n  width: 100%;\n  ', '\n  ', '\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    width: 50%;\n    padding-right: 4rem;\n    margin-top: 0rem;\n  '], ['\n    width: 50%;\n    padding-right: 4rem;\n    margin-top: 0rem;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['width: 60%'], ['width: 60%']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  margin: 2rem 0 2rem;\n'], ['\n  text-align: center;\n  margin: 2rem 0 2rem;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['width: 50%'], ['width: 50%']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['width: 40%'], ['width: 40%']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  ', '\n\n  i {\n    font-size: 1rem;\n  }\n'], ['\n  ', '\n\n  i {\n    font-size: 1rem;\n  }\n']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['padding-left: 100px;'], ['padding-left: 100px;']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n  ', '\n\n  padding: 1rem;\n  border: 1px dashed ', ';\n'], ['\n  ', '\n\n  padding: 1rem;\n  border: 1px dashed ', ';\n']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['margin-left: 100px;'], ['margin-left: 100px;']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  position: relative;\n'], ['\n  display: inline-block;\n  position: relative;\n']),
	    _templateObject16 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  display: block;\n  width: 100px;\n  font-size: 2rem;\n  line-height: 2rem;\n  padding: 1rem;\n  top: -5rem;\n  left: 0;\n  border-bottom: 1px solid ', ';\n\n  > a {\n    color: ', ';\n  }\n'], ['\n  position: absolute;\n  display: block;\n  width: 100px;\n  font-size: 2rem;\n  line-height: 2rem;\n  padding: 1rem;\n  top: -5rem;\n  left: 0;\n  border-bottom: 1px solid ', ';\n\n  > a {\n    color: ', ';\n  }\n']),
	    _templateObject17 = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: 100%;\n  ', '\n  ', '\n  ', ';\n  ', '\n\n  margin-top: 4rem;\n\n  > section {\n    padding: 0 0 3rem;\n\n    ', '\n\n    > div {\n      ', ';\n\n      > h2 {\n        position: relative;\n        left: -1rem;\n        padding: 0 0 1rem 1rem;\n        border-bottom: 1px solid ', ';\n      }\n    }\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 100%;\n  ', '\n  ', '\n  ', ';\n  ', '\n\n  margin-top: 4rem;\n\n  > section {\n    padding: 0 0 3rem;\n\n    ', '\n\n    > div {\n      ', ';\n\n      > h2 {\n        position: relative;\n        left: -1rem;\n        padding: 0 0 1rem 1rem;\n        border-bottom: 1px solid ', ';\n      }\n    }\n  }\n']),
	    _templateObject18 = _taggedTemplateLiteralLoose(['\n    grid-auto-rows: 1fr;\n    grid-template-columns: 50% 50%;'], ['\n    grid-auto-rows: 1fr;\n    grid-template-columns: 50% 50%;']),
	    _templateObject19 = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject20 = _taggedTemplateLiteralLoose(['\n    grid-template-columns: 33% 33% 34%;\n  '], ['\n    grid-template-columns: 33% 33% 34%;\n  ']),
	    _templateObject21 = _taggedTemplateLiteralLoose(['grid-template-columns: 20% 20% 20% 20% 20%;'], ['grid-template-columns: 20% 20% 20% 20% 20%;']),
	    _templateObject22 = _taggedTemplateLiteralLoose(['\n      padding: 0 1rem 1rem 0;\n    '], ['\n      padding: 0 1rem 1rem 0;\n    ']),
	    _templateObject23 = _taggedTemplateLiteralLoose(['\n        border-left: 1px solid ', ';\n      '], ['\n        border-left: 1px solid ', ';\n      ']),
	    _templateObject24 = _taggedTemplateLiteralLoose(['\n  background: rgb(255, 255, 255);\n  color: black;\n  text-align: center;\n\n  > h1 {\n    margin: 2rem 0 4rem;\n  }\n'], ['\n  background: rgb(255, 255, 255);\n  color: black;\n  text-align: center;\n\n  > h1 {\n    margin: 2rem 0 4rem;\n  }\n']),
	    _templateObject25 = _taggedTemplateLiteralLoose(['\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n'], ['\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n']),
	    _templateObject26 = _taggedTemplateLiteralLoose(['\n  height: 50px;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));\n  position: relative;\n  padding: 0 2rem;\n\n  > div {\n    position: absolute;\n    bottom: -100px;\n    left: 50px;\n  }\n\n  .logo {\n    animation: ', ' 12s linear infinite;\n  }\n'], ['\n  height: 50px;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));\n  position: relative;\n  padding: 0 2rem;\n\n  > div {\n    position: absolute;\n    bottom: -100px;\n    left: 50px;\n  }\n\n  .logo {\n    animation: ', ' 12s linear infinite;\n  }\n']),
	    _templateObject27 = _taggedTemplateLiteralLoose(['\n  height: 50px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));\n  position: relative;\n  padding: 0 2rem;\n\n  > div {\n    position: absolute;\n    top: -100px;\n    right: 50px;\n  }\n\n  .logo {\n    animation: ', ' 12s linear infinite reverse;\n  }\n'], ['\n  height: 50px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));\n  position: relative;\n  padding: 0 2rem;\n\n  > div {\n    position: absolute;\n    top: -100px;\n    right: 50px;\n  }\n\n  .logo {\n    animation: ', ' 12s linear infinite reverse;\n  }\n']),
	    _templateObject28 = _taggedTemplateLiteralLoose(['\n  padding:  2rem 2rem 6rem !important;\n  background: white;\n  color: black;\n\n  p {\n    max-width: 900px;\n    margin: 0 auto;\n  }\n'], ['\n  padding:  2rem 2rem 6rem !important;\n  background: white;\n  color: black;\n\n  p {\n    max-width: 900px;\n    margin: 0 auto;\n  }\n']),
	    _templateObject29 = _taggedTemplateLiteralLoose(['\n'], ['\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledWrapper = exports.StyledWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return (0, _styleUtils.backgroundTheme)(props.themeColors);
	}, function (props) {
	  return props.textColor;
	});
	
	var LeaderboardsWrapper = exports.LeaderboardsWrapper = _styledComponents2.default.section(_templateObject2, function (props) {
	  return props.textColor;
	});
	
	var TopSection = exports.TopSection = _styledComponents2.default.section(_templateObject3, _styleUtils.media.fromMedium(_templateObject4));
	
	var TitleSection = exports.TitleSection = _styledComponents2.default.section(_templateObject5, _styleUtils.media.fromMedium(_templateObject6), _styleUtils.media.fromLarge(_templateObject7));
	
	var CenteredHeading = exports.CenteredHeading = _styledComponents2.default.div(_templateObject8);
	
	var NutrientsSection = exports.NutrientsSection = _styledComponents2.default.section(_templateObject5, _styleUtils.media.fromMedium(_templateObject9), _styleUtils.media.fromLarge(_templateObject10));
	
	var NutrientsHeader = exports.NutrientsHeader = _styledComponents2.default.header(_templateObject11, _styleUtils.media.fromMedium(_templateObject12));
	
	var MissingNutrientText = exports.MissingNutrientText = _styledComponents2.default.p(_templateObject13, _styleUtils.media.fromMedium(_templateObject14), function (props) {
	  return props.textColor;
	});
	
	var ServingText = exports.ServingText = _styledComponents2.default.p(_templateObject15);
	
	var HomeLinkWrap = exports.HomeLinkWrap = _styledComponents2.default.div(_templateObject16, function (props) {
	  return props.textColor;
	}, function (props) {
	  return props.textColor;
	});
	
	var CardsSection = exports.CardsSection = _styledComponents2.default.section(_templateObject17, _styleUtils.media.fromSmall(_templateObject18), _styleUtils.media.fromMedium(_templateObject19), _styleUtils.media.fromLarge(_templateObject20), _styleUtils.media.fromXLarge(_templateObject21), _styleUtils.media.fromSmall(_templateObject22), _styleUtils.media.fromSmall(_templateObject23, function (props) {
	  return props.textColor;
	}), function (props) {
	  return props.textColor;
	});
	
	var ResearchSection = exports.ResearchSection = _styledComponents2.default.section(_templateObject24);
	
	var spinLogoAnimation = (0, _styledComponents.keyframes)(_templateObject25);
	
	var AbstractLogosSectionTop = exports.AbstractLogosSectionTop = _styledComponents2.default.section(_templateObject26, spinLogoAnimation);
	
	var AbstractLogosSectionBottom = exports.AbstractLogosSectionBottom = _styledComponents2.default.section(_templateObject27, spinLogoAnimation);
	
	var TooMuchSection = exports.TooMuchSection = _styledComponents2.default.section(_templateObject28);
	
	var BuySection = exports.BuySection = _styledComponents2.default.section(_templateObject29);

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-food-template-food-template-js-306eed01894fde0a1ec7.js